import { Fragment, useEffect } from "react";
import { signal } from "@preact/signals-react";
import { useNavigate, useParams } from "react-router";
import { FormattedMessage as FM } from "react-intl";

import TitleHero from "../components/ui/TitleHero";
import Sections from "../components/ui/Sections";
import proxy from "api/proxy";
import { Alert } from "components/Alerts/Alert";
import funcs from "tools/functions";
import Button from "componentsv2/button/Button";
import { cn } from "tools/ui";
import TableGuest from "../components/TableGuests";
import Contract from "../components/Contract";
import { TYPES } from "../../constant/constant.jsx";
import Signature from "../components/Signature";
import Dialog from "componentsv2/modal/Dialog";
import Experiences from "ext-apps/WebCheckIn/components/Experiences";
import ContetSelectLan from "../components/ContetSelectLan";
// import FinishPage from "./FinishTraPage";

const PREFIX = "hotel.folio.guest";

const signature = signal(false);
const checked = signal(false);
const openModal = signal(false);
const openModalLang = signal(true);
const alertMsg = signal({
  show: false,
  text: null,
  icon: "check",
  color: "bg-green-200",
  position: "fixed",
  className: "bottom-0 max-w-[400px] left-0  right-0",
  autoRemove: true,
});

function ItemLabel({ label, value, colSpan, translate = false }) {
  const _label = `${PREFIX}.${label}`;
  const _value = value ? value : "NA";
  return (
    <div className={cn(`flex flex-col`, colSpan)}>
      <span className="font-semibold text-sm text-gray-800">
        <FM id={_label} />
      </span>
      <span className="text-sm text-gray-600 truncate">
        {translate ? <FM id={`${PREFIX}.${value}`} /> : _value}
      </span>
    </div>
  );
}

const Tra = ({ folio, configHotel }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const _folio = folio?.[0] || {};
  const guest = _folio?.["main_guest."] || "";
  const guests = _folio?.["guests."] || [];
  const booking = _folio?.["booking."] || "";
  const channel = booking?.["channel."]?.name || "";

  const handleChangeCheckContract = (e) => {
    checked.value = e.target.checked;
  };

  if (!id) {
    return <div>Configura ambiente o el folio no existe</div>;
  }

  const typeDocument =
    TYPES.find((item) => item.id === guest.type_document)?.name || "";

  const renderItem = [
    { label: "Nombres", value: guest.name, colSpan: "col-span-2" },
    { label: "birthday", value: guest.birthday },
    { label: "id_number", value: guest.id_number },
    { label: "typeDocument", value: typeDocument, translate: true },
    { label: "sex", value: guest.sex, translate: true },
    { label: "nationality", value: guest?.["nationality."]?.name },
    { label: "target_country", value: guest?.["nationality."]?.name },
    { label: "type_accomodation", value: _folio?.["product."]?.name },
    { label: "room", value: _folio?.["room."]?.name },
    { label: "phone", value: guest?.phone || guest?.mobile },
    { label: "email", value: guest.email },
    { label: "arrival_date", value: _folio?.arrival_date },
    { label: "departure_date", value: _folio?.departure_date },
    { label: "nights_quantity", value: _folio?.nights_quantity },
    { label: "unit_price", value: _folio?.unit_price },
    { label: "payment_status", value: _folio?.payment_status },
    {
      label: "channel",
      value: channel,
    },
    { label: "reason", value: _folio?.booking?.reason || "" },
    { label: "Tipo de Ocupante", value: "Adulto" },
    { label: "company", value: guest.company || "" },
    { label: "Identificación Empresa", value: guest.company_id || "" },
    { label: "nationality", value: guest?.["nationality."]?.name || "" },
    { label: "vehicle_plate", value: _folio?.vehicle_plate || "" },
  ];

  async function saveSignature(value) {
    const { name, image } = value;
    const toStore = { files: {} };
    toStore.files[name] = image;
    toStore.id = _folio.id;

    const attrs = {
      model: "hotel.folio",
      ids: [_folio.id],
      values: toStore,
    };
    const { data: res, error } = await proxy.save(attrs);
    if (!error) {
      signature.value = true;
      alertMsg.value = {
        ...alertMsg.value,
        show: true,
        text: "hotel.folio.signature.updated",
        icon: "check",
        color: "bg-green-200",
      };
    }
  }

  async function handleGetRegistrationCard() {
    const storeStd = {
      company: configHotel.value.company,
      id: _folio.id,
    };

    const { reportUrl, nameFile } = await proxy.report({
      report: "hotel.folio.registration_card",
      data: storeStd,
      records: [_folio.id],
    });

    if (reportUrl && nameFile) {
      await funcs.createReportLink(reportUrl, nameFile);
      navigate("success");
    }
  }
  function disableMsg() {
    alertMsg.value = {
      ...alertMsg.value,
      show: true,
      text: "hotel.folio.guest.accept_contract",
      icon: "xmark",
      color: "bg-red-200",
    };
  }

  useEffect(() => {
    signature.value = !!_folio?.signature;
    openModalLang.value = true;
  }, [_folio?.signature]);

  return (
    <Fragment>
      <div>
        <TitleHero
          name={guest?.name?.trim().split(" ")[0]}
          desc="hotel.folio.guest.welcome_tra"
          style="!max-w-[737px]"
          logo={configHotel.value?.["company."]?.logo_link}
        />

        <div className="space-y-7">
          <Sections title="hotel.folio.guest.content_info_folio" icon={"user"}>
            <div className="space-y-3 gap-y-7 tablet:grid tablet:grid-cols-2 tablet:gap-y-1  md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-10 md:space-x-2 ">
              {renderItem.map((item, index) => (
                <ItemLabel
                  key={index}
                  label={item.label}
                  value={item?.value}
                  colSpan={item?.colSpan}
                  translate={item?.translate}
                />
              ))}
            </div>
          </Sections>

          <Sections title="hotel.folio.guest.content_guest" icon="people">
            <TableGuest guests={guests} TYPES={TYPES} PREFIX={PREFIX} />
          </Sections>

          <Sections title="hotel.folio.guest.content_contract" icon="contract">
            <Contract
              handleChangeCheckContract={handleChangeCheckContract}
              checked={checked}
              configHotel={configHotel}
            />
          </Sections>

          <Sections title="hotel.folio.guest.content_signature" icon="pencil">
            {!checked.value && (
              <p className="text-sm text-red-600">
                <FM id="hotel.folio.guest.accept_contract" />
              </p>
            )}

            <Signature
              label="Firma Huésped"
              model="hotel.tra"
              name="signature"
              onSave={saveSignature}
              className={`mb-5 ${checked.value ? "" : "opacity-30 !cursor-no-allowed"}`}
              value={_folio?.signature}
              disabled={!checked.value}
              disableMsg={disableMsg}
            />
            <Dialog
              title="app.webcheckin.register_guest"
              model="hotel.tra"
              name="signature"
              onSave={saveSignature}
              className={`mb-5 ${checked.value ? "" : "opacity-30 !cursor-no-allowed"}`}
              value={_folio?.signature}
              disabled={!checked.value}
              disableMsg={disableMsg}
            />

            {signature.value && checked.value && (
              <div className="mt-2">
                <Button
                  color="amber"
                  content="hotel.folio.guest.btn_finish"
                  onClick={handleGetRegistrationCard}
                  style="mx-auto"
                  loading={true}
                />
              </div>
            )}
          </Sections>
        </div>
      </div>
      <Dialog
        openModal={openModal}
        handleClose={() => (openModal.value = false)}
        size="h-max w-[400px] md:w-[1000px]"
        title={"Conoce mas sobre nuestras experiencias"}
        styleTitle="text-center w-full"
      >
        <Experiences transparentLayer={true} />
      </Dialog>
      <Dialog openModal={openModalLang} hiddenHeader={true} size="w-[700px]">
        <ContetSelectLan handleClose={() => (openModalLang.value = false)} />
      </Dialog>
      {/* <FinishPage />*/}
      <Alert
        {...alertMsg.value}
        onClose={() => (alertMsg.value = { ...alertMsg.value, show: false })}
      />
    </Fragment>
  );
};

export default Tra;
